<template>
  <v-container>
    <v-layout row>
      <v-flex xs12 style="text-align:center;">
        <v-card
          justify="center"
          class="text-center elevation-5 primary"
          style="margin: auto; margin-bottom: 20px;max-width: 700px;padding: 20px; border-radius: 10px;"
        >
          <v-btn fab small color="red" @click="Cancel" style=" float:right">
            <v-icon dark flat style="font-size:25px; color:white; "
              >close</v-icon
            >
          </v-btn>
          <div>
            <h1 style="color:white; width: fit-content; margin-top: 10px;">
              Suggest A Post Here:
            </h1>
            <v-form style="margin-top:10px">
              <v-flex>
                <v-text-field
                  v-model="title"
                  label="*Title or Topic"
                  single-line
                  solo
                  required
                  style="margin-top:30px"
                  v-on:keyup.enter="nothing()"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-autocomplete
                  v-model="chosenTags"
                  :items="possibleTags.topics"
                  solo
                  dense
                  required
                  chips
                  small-chips
                  label="*Topic Tags"
                  multiple
                >
                  <template slot="selection" slot-scope="data" pa-5>
                    <v-chip
                      text-color="white"
                      :selected="data.selected"
                      close
                      class="chip--select-multi titles"
                      @input="data.parent.selectItem(data.item)"
                    >
                      {{ data.item }}
                    </v-chip>
                  </template>

                  <template slot="item" slot-scope="data">
                    <v-list-tile-content
                      v-text="data.item"
                    ></v-list-tile-content>
                  </template>
                </v-autocomplete>
              </v-flex>
              <v-flex style="padding-bottom: 15px;">
                <v-autocomplete
                  v-model="location"
                  :items="possibleTags.location"
                  cache-items
                  flat
                  hide-no-data
                  hide-details
                  label="*Location"
                  solo
                  dense
                  required
                ></v-autocomplete>
              </v-flex>

              <v-flex style="padding-bottom: 15px;">
                <v-textarea
                  label="Other Comments and Questions to Consider"
                  solo
                  v-model="comments"
                  hint="Other Comments"
                  counter="1000"
                  :rules="[rules.length(1000)]"
                ></v-textarea>
              </v-flex>

              <v-flex>
                <label>Press Enter or Use Commas to Separate Sources</label>
                <v-combobox
                  multiple
                  v-model="commentSources1"
                  clearable
                  :items="commentSources1"
                  label="*Sources"
                  class="link-input"
                  append-icon
                  chips
                  :search-input.sync="commentSources"
                  @keyup.,="linkTabs"
                  @paste="linkTabs"
                  solo
                  deletable-chips
                >
                  <template v-slot:selection="{ index }">
                    <v-chip v-if="index == 0">
                      <v-icon style="font-size:20px; ">add_link</v-icon>
                      &nbsp;{{ commentSources1.length }}
                    </v-chip>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-icon style="font-size:20px; ">cancel</v-icon>
                    <h3
                      style="color: black; width: 100%; padding-left: 5px; white-space: nowrap;"
                    >
                      {{ item }}
                    </h3>
                  </template>
                </v-combobox>
              </v-flex>

              <v-btn
                @click="storyUpload"
                class="titles"
                style="border-radius: 20px;  color:white; margin-top:30px"
              >
                <v-icon dark style="font-size:22px; ">done</v-icon
                >&nbsp;&nbsp;Suggest Post
              </v-btn>

              <v-dialog v-model="dialog" width="290" persistent>
                <v-card style="border-radius: 10px">
                  <v-card-title class="titles" style="color:white">
                    Post Sumbitted
                  </v-card-title>

                  <v-card-actions class="chatbackground">
                    <v-spacer></v-spacer>

                    <v-btn
                      color="titles"
                      class="elevation-4"
                      text
                      @click="(dialog = false), Cancel()"
                      style="border-radius:20px; color:white"
                    >
                      Home
                    </v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-form>
          </div>
          <div v-show="isAdmin">
            <h1
              style="color:white; width: fit-content; margin-top: 10px; margin-bottom: 10px;"
            >
              Suggestions:
            </h1>
            <v-card
              v-for="suggest in suggestions"
              :key="suggest.title + suggest.creatorID"
              class="chatbackground"
              style="border-radius: 10px; margin-bottom: 15px; padding: 10px; text-align: start;"
            >
              <v-checkbox
                v-model="suggest.read"
                label="Read"
                color="titles"
                @change="updateRead(suggest.suggestion_id, suggest.read)"
                style="float: right;margin-right: 10px; margin-top: 0px;"
              ></v-checkbox>
              <h3 style="text-transform: capitalize; margin-bottom: -15px;">
                Title: {{ suggest.title }}
              </h3>
              <br />
              Links:
              <v-chip
                class="titles secondary--text"
                :href="links"
                target="_blank"
                v-for="links in suggest.links"
                :key="links + suggest.creatorID"
              >
                {{ links }}
              </v-chip>
              <br />
              Tags:
              <v-chip
                class="titles secondary--text"
                v-for="tags in suggest.tags"
                :key="tags + suggest.creatorID"
              >
                {{ tags }}
              </v-chip>
              <br />
              Location:
              <v-chip class="titles secondary--text">
                {{ suggest.location }}
              </v-chip>
              <br />
              Comments: {{ suggest.comments }}
            </v-card>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

import firebase from "firebase";
import "firebase/firestore";

export default {
  data() {
    return {
      loading: false,
      editing: false,
      userID: null,
      links: "",
      possibleTags: {
        topics: [
          "Congress",
          "Environment",
          "Education",
          "Supreme Court",
          "Public Health",
          "Public Safety",
          "Military",
          "Economy",
          "International Affairs",
          "Social Justice",
          "Federal Spending",
          "Technology",
          "Entertainment",
          "Human Rights",
          "Litigation",
          "Politics",
        ],
        location: [
          "United States",
          "Alabama",
          "Alaska",
          "American Samoa",
          "Arizona",
          "Arkansas",
          "California",
          "Colorado",
          "Connecticut",
          "Delaware",
          "Washington D.C.",
          "Florida",
          "Georgia",
          "Guam",
          "Hawaii",
          "Idaho",
          "Illinois",
          "Indiana",
          "International",
          "Iowa",
          "Kansas",
          "Kentucky",
          "Louisiana",
          "Maine",
          "Maryland",
          "Massachusetts",
          "Michigan",
          "Minnesota",
          "Mississippi",
          "Missouri",
          "Montana",
          "Nebraska",
          "Nevada",
          "New Hampshire",
          "New Jersey",
          "New Mexico",
          "New York",
          "North Carolina",
          "North Dakota",
          "Northern Mariana Islands",
          "Ohio",
          "Oklahoma",
          "Oregon",
          "Pennsylvania",
          "Puerto Rico",
          "Rhode Island",
          "South Carolina",
          "South Dakota",
          "Tennessee",
          "Texas",
          "U.S. Virgin Islands",
          "Utah",
          "Vermont",
          "Virginia",
          "Washington",
          "West Virginia",
          "Wisconsin",
          "Wyoming",
        ],
      },
      chosenTags: [],
      i: 0,
      title: "",
      menuProps: {
        disabled: false,
      },
      location: "",
      verified: false,
      dialog: false,
      commentSources: "",
      commentSources1: [],
      isAdmin: false,
      suggestions: [],
      comments: "",
      rules: {
        length: (len) => (v) => (v || "").length <= len || false,
      },
    };
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val);
    },
  },
  computed: {
    ...mapState(["user", "userProfile", "userNames"]),
  },
  mounted: function() {
    var self = this;
    setTimeout(async function() {
      self.userID = self.userProfile.uid;
      self.isAdmin = self.userProfile.isAdmin;
      if (self.isAdmin) {
        await firebase
          .firestore()
          .collection("suggestions")
          .get()
          .then((docs) => {
            docs.docs.forEach((doc) => {
              self.suggestions.push(doc.data());
              self.suggestions.sort((a, b) => {
                
              if (a.read && b.read) {
                return b.readTime - a.readTime;
              } else if (!a.read && !b.read) {
                return a.time - b.time;
              } else {
               return a.read - b.read;
              }
            })
            })
            
          });
      }
    }, 2000);
  },
  methods: {
    linkTabs() {
      this.$nextTick(() => {
        this.commentSources1.push(this.commentSources.split(",")[0]);
        this.commentSources = "";
      });
    },
    getSources() {
      if (this.commentSources1 != []) {
        const sources = this.commentSources1;

        var i = 0;
        for (i = 0; i < sources.length; i++) {
          var reg = /(www.|http:\/\/|https:\/\/)*/;
          var str = sources[i].replace(reg, "");
          sources[i] = str.trim();
        }
        return sources;
      } else {
        return [];
      }
    },

    querySelections(v) {
      this.loading = true;
      setTimeout(() => {
        this.items = this.possibleTags.location.filter((e) => {
          return (e || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1;
        });
        this.loading = false;
      }, 500);
    },
    updateRead(id, read) {
      firebase
        .firestore()
        .collection("suggestions")
        .doc(id)
        .update({ read: read, readTime: Date.now() });

      this.suggestions.sort((a, b) => {
                
              if (a.read && b.read) {
                return b.readTime - a.readTime;
              } else if (!a.read && !b.read) {
                return a.time - b.time;
              } else {
               return a.read - b.read;
              }
            });
    },
    storyUpload() {
      this.$store.dispatch("uploadSuggestion", {
        title: this.title.toLowerCase(),
        userID: this.userID,
        sources: this.getSources(),
        tag: this.chosenTags,
        location: this.location,
        comments: this.comments,
      });
      this.dialog = true;
    },
    Cancel() {
      this.$router.push("/news");
    },
    nothing() {},
    clear() {
      this.chosenTags = [];
      this.title = "";
      this.location = "";
    },
  },
};
</script>
